<template>
  <footer
    class="footer"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <div class="social-media">
        <a
          class="nav-link"
          rel="tooltip"
          title="Follow me on Instagram"
          data-placement="bottom"
          href="https://www.instagram.com/mathiasmoelle_r"
          target="_blank"
        >
          <i class="fab fa-instagram"></i>
        </a>
        <a
          class="nav-link"
          rel="tooltip"
          title="Follow me on Facebook"
          data-placement="bottom"
          href="https://www.facebook.com/matze.moller.9"
          target="_blank"
        >
          <i class="fab fa-facebook-square"></i>
        </a>
        <a
          class="nav-link"
          rel="tooltip"
          title="Get in touch"
          data-placement="bottom"
          href="mailto:mail@mathiasmoeller.com"
          target="_blank"
        >
          <i class="fas fa-envelope"></i>
        </a>
      </div>

      <nav class="links">
        <router-link class="footer-link" to="/gallery">
          Gallery
        </router-link>
        <router-link class="footer-link" to="/about">
          About
        </router-link>
        <router-link class="footer-link" to="/buy">
          Buy
        </router-link>
        <router-link class="footer-link" to="/imprint">
          Imprint
        </router-link>
      </nav>

      <div class="copyright-box">
        &copy; Mathias Möller - All Rights Reserved - {{ year }}
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    props: {
      backgroundColor: String,
      type: String,
    },
    data() {
      return {
        year: new Date().getFullYear(),
      };
    },
  };
</script>
<style lang="scss" scoped>
  .social-media {
    display: flex;
    justify-content: center;
    font-size: 18px;

    .fas {
      font-size: 20px;
    }
  }

  nav.links {
    justify-content: center;
    display: flex;
    float: none;
    margin: 12px 0 16px 0;

    @media (max-width: 576px) {
      flex-direction: column;
      align-items: center;
    }
  }

  .footer-link {
    text-transform: uppercase;
    padding: 0 12px;


    &:not(:last-child) {
      border-right: solid white 1px
    }

    @media (max-width: 576px) {
      padding: 12px 30px;
      width: 120px;
      text-align: center;

      &:not(:last-child) {
        border-right: 0;
        border-bottom: solid white 1px;
      }
    }
  }

  .copyright-box {
    justify-content: center;
    display: flex;
    float: none;
    text-align: center;
  }
</style>
